import { useRecoilState } from 'recoil';
import ModeToggle from '~/components/toolbar/OperationsToolbar/ModeToggle';
import { rectangleSelectModeState } from '~/state/atoms/toolsAtoms';

/**
 * The rectangle erase's only option: how deep the drawn rectangle is
 * extruded along the slice normal.
 *
 * Reuses the panels' {@link ModeToggle} rather than the tool trays' own,
 * with its own label and sentence: here the two buttons pick a depth, not
 * a connectivity, which is why the control is shared but the wording is
 * not. What the gesture DOES lives in that sentence, on the Info icon
 * beside the toggle.
 */
export default function RectangleEraseToolOptions() {
    const [mode, setMode] = useRecoilState(rectangleSelectModeState);
    return (
        <ModeToggle
            mode={mode}
            onChange={setMode}
            disabled={false}
            labelId="postProcessing.delete.rectangleModeLabel"
            tooltipId="postProcessing.delete.rectangleModeTooltip"
        />
    );
}
